import type { FC, MouseEventHandler } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { useShallowPickSelector } from "store/useSelector";
import { BottomSheet } from "components/atoms/BottomSheet";
import { appActions } from "store/app/app.slice";
import { ReactComponent as FlagSVG } from "assets/images/flag.svg";
import { ReactComponent as ShareSVG } from "assets/images/share.svg";
import { ReactComponent as UserSVG } from "assets/images/profile-outline.svg";

export const UserMenu: FC = () => {
  const { userMenu } = useShallowPickSelector("app", ["userMenu"]);
  const { user, auth } = useShallowPickSelector("currentUser", [
    "user",
    "auth",
  ]);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const _location = useLocation();

  const onClose = () => {
    dispatch(
      appActions.setUserMenu({
        isOpen: false,
        userId: null,
        shouldShowProfileButton: false,
      })
    );
  };

  const onClickReport: MouseEventHandler = () => {
    if (userMenu.userId) {
      dispatch(
        appActions.setReportUserMenu({ isOpen: true, userId: userMenu.userId })
      );
      onClose();
    }
  };

  const onClickShareProfile: MouseEventHandler = () => {
    if (userMenu) {
      const shareData = {
        url: `https://avagap.com/profile/@${userMenu.userId}`,
      };
      if (
        !!navigator.share &&
        !!navigator.canShare &&
        navigator.canShare(shareData)
      ) {
        onClose();
        navigator.share(shareData);
      } else if (!!navigator.clipboard && !!navigator.clipboard.writeText) {
        navigator.clipboard.writeText(shareData.url).then(() => {
          dispatch(
            appActions.setSnackbar({
              isOpen: true,
              message: "لینک کاربر کپی شد",
              severity: "info",
            })
          );
          onClose();
        });
      }
    }
  };

  const onClickShowProfile: MouseEventHandler = () => {
    if (userMenu.userId) {
      navigate(`/users/${userMenu.userId}`);
      onClose();
    }
  };

  return (
    <BottomSheet
      title={"گزینه‌ها"}
      isOpen={userMenu.isOpen}
      onClose={onClose}
      items={[
        userMenu.shouldShowProfileButton
          ? {
              text: "مشاهدهٔ پروفایل",
              icon: <UserSVG />,
              onClick: onClickShowProfile,
            }
          : null,
        { text: "گزارش کاربر", icon: <FlagSVG />, onClick: onClickReport },
        {
          text: "اشتراک‌گذاری",
          icon: <ShareSVG />,
          onClick: onClickShareProfile,
        },
      ]}
    />
  );
};
